import ButtonLine from 'components/commons/buttons/buttonLine/ButtonLine';
import { useTranslate } from 'context/languageContext';
import UseLines from 'hooks/useLines/UseLines';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { lineState } from 'redux/slices/linesSlice';
import { updateTooltipModal } from 'redux/slices/mapSlice';

interface OverlappingLinesContentProps {
  lines: Array<number>;
}

export default function OverlappingLinesContent(props: OverlappingLinesContentProps) {
  const allLines = useSelector(lineState);
  const t = useTranslate();
  const dispatch = useDispatch();
  const {getLineInfo} = UseLines();
  const sortedLines = [...props.lines]?.sort((a: any, b: any) => {
    const lineFoundA =  allLines.find((element: any) => String(element.id) === String(a));
    const lineFoundB =  allLines.find((element: any) => String(element.id) === String(b));

    if (lineFoundA && lineFoundB) {
      return lineFoundA?.routeSortOrder - lineFoundB?.routeSortOrder;
    }

    return -1;
  });

  function renderLines() {
    let contentLines: any = [];

    sortedLines.forEach((line: number) => {
      let lineFound = allLines.find((element: any) => String(element.id) === String(line));
      if (lineFound) {
        contentLines.push(
          <ButtonLine
            key={`${lineFound?.code}-tooltip`}
            code={lineFound?.code}
            routeColor={lineFound?.routeColor || '#869898'}
            routeTextColor={lineFound?.routeTextColor || '#FFFFFF'}
            onClick={() => {
              dispatch(updateTooltipModal(undefined));
              getLineInfo(lineFound);
            }}
          />,
        );
      }
    });

    return contentLines;
  }

  return (
    <>
      {`${props.lines.length} ${props.lines.length > 1 ? t('lb_overlapping_lines_desc') : t('lb_overlapping_line1_desc')}`}
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', maxWidth: 196, columnGap: 4, rowGap: 4, marginTop: 8,  }}>
        {renderLines()}
      </div>
    </>
  );
}
